import './dashboard.less';

import classNames from 'classnames';
import React from 'react';
import {Link, browserHistory} from 'react-router';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import MediaQuery from 'react-responsive';
import dashboardActions from './dashboard_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import ShowError from '../components/error/show_error';
import CONSTANTS from '../common_constants';
import moment from 'moment';
import LoggedinFooter from '../footer/loggedin_footer';
import ModalPopUp from '../components/modalPopUp/modalPopUp';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import ShipmentDetail from './shipment_detail';
import EmptyShipments from './empty_shipment';
import cookies from '../util/cookie';
import ConfirmDeleteComponent from '../components/confirm_box/confirm_box';

class Shipment extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      showConfirmBox : false,
      shipmentId : ""
    }
  }
  cancelAction = () =>{
    let paramObj ={
        shipmentId : this.state.shipmentId
    }
    const self = this;
    this.props.dashboardActions.cancelOffer(paramObj).then((data) => {
          self.props.reloadCaryyingPackages();
      },(errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.props.authActions.sessionValid(false);
          this.setState({isLoading: false})
          cookies.delete('_sd');
          return ;
        }
        this.setState({
          isLoading: false,
          error: errorRes.error
        })
      });
  }
  toggleShowConfirmBox = (shipmentId , e) =>{
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({
      showConfirmBox : !this.state.showConfirmBox,
      shipmentId
    })
  }
  render(){
    const {props, state} = this;
    let {shipments} = props;
    let shipmentSection = CONSTANTS.shipmentSection.IM_CARRYING;
    const no_carrier_img = "../../public/images/dashboard/no_carrier.png";
    return(
      <div className = "shipment-detail-wrap">
        {state.error && <ShowError errorMessage={state.error}/>}
        <ConfirmDeleteComponent
          onConfirmCallback = {this.cancelAction}
          closePopupCallback = {this.toggleShowConfirmBox}
          header = "Confirm"
          description = "Are you sure that you want to cancel the offer?"
          popupState = {state.showConfirmBox}/>
        {
          shipments.approved && shipments.approved.length > 0 && shipments.approved.map( (shipment,index) => {
            return(
              <div className="delivered-packages">
                <ShipmentDetail
                  shipment = {shipment}
                  key={index}
                  isShipper = {false}
                  backTo = {'carrying'}/>
                {shipment.shipmentType == 2 && shipment.shipperProfileImageUrl && !shipment.isBlocked &&
                    <MediaQuery query='(max-width: 767px)' >
                      <img className="request-profile-img-url" src={shipment.shipperProfileImageUrl} />
                    </MediaQuery>
                  }
              </div>
            )
          })
        }
        {shipments.pendingApproval && shipments.pendingApproval.length > 0 && <h2 className = "shipment-package-header">Pending approval</h2> }
        {
          shipments.pendingApproval && shipments.pendingApproval.length > 0 && shipments.pendingApproval.map( (shipment,index) => {
            return(
              <div className="delivered-packages">
                <ShipmentDetail
                  toggleShowConfirmBox = {this.toggleShowConfirmBox}
                  shipmentSection = {ShipmentDetail}
                  shipment = {shipment}
                  key = {index}
                  isShipper = {false}
                  backTo = {'carrying'}/>
                  <span className="pending-packages-icon status-img"></span>

                  {shipment.shipmentType == 2 && shipment.shipperProfileImageUrl && !shipment.isBlocked &&
                    <MediaQuery query='(max-width: 767px)' >
                      <img className="request-profile-img-url" src={shipment.shipperProfileImageUrl} />
                    </MediaQuery>
                  }
              </div>
            )
          })
        }
        {shipments.delivered && shipments.delivered.length > 0 && <h2 className = "shipment-package-header">Delivered</h2> }
        {
          shipments.delivered && shipments.delivered.length > 0 && shipments.delivered.map( (shipment,index) => {
            return(
              <div className="delivered-packages">
                <ShipmentDetail
                  delivered={true}
                  shipment = {shipment}
                  key={index}
                  isShipper = {false}
                  backTo = {'carrying'}/>
                  {shipment.shipmentStatus === 9 && <span className="delivered-packages-icon status-img"></span>}
                  {shipment.shipmentType == 2 && shipment.shipperProfileImageUrl && !shipment.isBlocked &&
                    <MediaQuery query='(max-width: 767px)' >
                      <img className="request-profile-img-url" src={shipment.shipperProfileImageUrl} />
                    </MediaQuery>
                  }
              </div>
            )
          })
        }
        {
          (shipments.approved && shipments.approved.length == 0 && shipments.delivered && shipments.delivered.length == 0 && shipments.pendingApproval && shipments.pendingApproval.length == 0) &&
            <EmptyShipments title={"Nothing to Carry"} info={"Get started by searching for available packages to carry"} imgURL = {no_carrier_img} />
        }
      </div>
    )
  }
}

class CarryingDashBoard extends React.Component{

  constructor(props){
    super(props);
    const {dashboard} = props;

    this.state = {
      isLoading: false,
      isCarrying: true,
      error: '',
      carryingPackages: dashboard && dashboard.carryingPackages || [],
      shippingCount: dashboard && dashboard.shippingCount,
      carryingCount: dashboard && dashboard.carryingCount,
      receivingCount: dashboard && dashboard.receivingCount
    }
    this.getCarryingPackages = this.getCarryingPackages.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  componentWillReceiveProps(newProps) {
    if(newProps.dashboard.carryingPackages) {
      this.setState({ carryingPackages:newProps.dashboard.carryingPackages,
                      shippingCount: newProps.dashboard.shippingCount,
                      carryingCount: newProps.dashboard.carryingCount,
                      receivingCount: newProps.dashboard.receivingCount
                    });
    }
  }

  componentDidMount(){
    this.reloadCaryyingPackages();
  }
  reloadCaryyingPackages = () =>{
    this.setState({isLoading: true});
    this.getCarryingPackages();
  }
  getCarryingPackages(){
    const {dashboardActions} = this.props;
    dashboardActions.getCarryingPackages().then(() => {
      this.setState({isLoading: false});
    }, (errorRes) => {
      if(errorRes.error === CONSTANTS.sessionInvalid){
        this.props.authActions.sessionValid(false);
        this.setState({isLoading: false})
        cookies.delete('_sd');
        return ;
      }
      this.setState({
        isLoading: false,
        error: errorRes.error
      })
    });
  }

  render(){
    const self = this;
    const {props, state} = this;
    const {carryingPackages, carryingCount, shippingCount, receivingCount} = state;
    let shipments = {};
    let sessionValid = true ;

    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid
    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isFirstTime;
    if(props.location)
       isFirstTime = props.location.query.isFirstTime;
    else
        isFirstTime = false;

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return(
      <div className = "">
        <div className = "d-tab-wrap">
          <div className = "wrapper tabs-wrap">
            <Link to="/dashboard/i-am-shipping">
              <div className = "d-tab-elm">
                I'M SHIPPING{shippingCount>0 && <span className = "shipping-count">{shippingCount}</span>}
              </div>
            </Link>
            <Link to="/dashboard/i-am-carrying">
              <div className = {classNames('d-tab-elm', {'active-nav-class' : state.isCarrying})}>
                I'M CARRYING{carryingCount>0 && <span className = "shipping-count">{carryingCount}</span>}
              </div>
            </Link>
            <Link to="/dashboard/i-am-receiving">
              <div className = "d-tab-elm">
                I'M RECEIVING{receivingCount>0 && <span className = "shipping-count">{receivingCount}</span>}
              </div>
            </Link>
          </div>
        </div>
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {state.error && <ShowError errorMessage={state.error}/>}
        <div className = "wrapper shipments-wrap">
          <Shipment
              reloadCaryyingPackages = {this.reloadCaryyingPackages}
              shipments={carryingPackages}
              dashboardActions = {this.props.dashboardActions}
              authActions = {this.props.authActions}
              authState = {this.props.authState}
          />
        </div>
      </div>
    )
  }
}

CarryingDashBoard = connect((state) => {
  return {
    dashboard: state.app.dashboard,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(CarryingDashBoard);

module.exports = CarryingDashBoard;



// WEBPACK FOOTER //
// app/dashboard/carrying_dashboard.jsx